import { render, staticRenderFns } from "./MealPlan.vue?vue&type=template&id=0fd267d7&"
import script from "./MealPlan.vue?vue&type=script&lang=js&"
export * from "./MealPlan.vue?vue&type=script&lang=js&"
import style0 from "./MealPlan.vue?vue&type=style&index=0&id=0fd267d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports